import { render } from "./BuildIcon4.vue?vue&type=template&id=76ded668&scoped=true"
import script from "./BuildIcon4.vue?vue&type=script&lang=js"
export * from "./BuildIcon4.vue?vue&type=script&lang=js"

import "./BuildIcon4.vue?vue&type=style&index=0&id=76ded668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ded668"]])

export default __exports__